import { render, staticRenderFns } from "./AttackCenterHeadbar.vue?vue&type=template&id=4c7d6834&"
import script from "./AttackCenterHeadbar.vue?vue&type=script&lang=js&"
export * from "./AttackCenterHeadbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports